export class TemplateMeasure {
    templateMeasureId: number;
    templateMeasureGroupId: number;
    measureId: number;
    measureName?: string;
    measureCode?: string;
    threshold: number;
    measureWeightId?: number;
    index?: number;
    groupIndex?: number;
    isEnabled: boolean;
}
